import * as React from "react";
import { connect } from "react-redux";
var _Overlay = function (_a) {
    var shouldRender = _a.shouldRender;
    return shouldRender ? React.createElement("div", { className: "overlay-block" }) : React.createElement(React.Fragment, null);
};
var mapState = function (state) {
    var isDogTreatCooldownRunning = state.doghouse.cooldownTime !== 0;
    var isFortuneTellerCooldownRunning = state.fortuneTellerEventInfo.cooldownTime !== 0;
    var shouldRender = isDogTreatCooldownRunning || isFortuneTellerCooldownRunning;
    return {
        shouldRender: shouldRender,
    };
};
export var Overlay = connect(mapState)(_Overlay);



//////////////////
// WEBPACK FOOTER
// ./src/features/overlay/Overlay.tsx
// module id = 1372
// module chunks = 3